var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import * as React from 'react';
import uniqueId from 'lodash/uniqueId';

import AccessibleSVG from '../accessible-svg';

var ICON_CLASS = 'unknown-user-avatar';

var UnknownUserAvatar = function (_React$PureComponent) {
    _inherits(UnknownUserAvatar, _React$PureComponent);

    function UnknownUserAvatar() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, UnknownUserAvatar);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UnknownUserAvatar.__proto__ || Object.getPrototypeOf(UnknownUserAvatar)).call.apply(_ref, [this].concat(args))), _this), _this.idPrefix = uniqueId(ICON_CLASS) + '-', _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(UnknownUserAvatar, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                height = _props.height,
                title = _props.title,
                width = _props.width;

            return React.createElement(
                AccessibleSVG,
                {
                    className: ICON_CLASS + ' ' + className,
                    height: height,
                    title: title,
                    viewBox: '0 0 28 28',
                    width: width
                },
                React.createElement(
                    'defs',
                    null,
                    React.createElement('circle', { id: this.idPrefix + 'a', cx: '14', cy: '14', r: '14' })
                ),
                React.createElement(
                    'g',
                    { fill: 'none', fillRule: 'evenodd' },
                    React.createElement('use', {
                        className: 'background-fill-color',
                        fill: '#EDEDED',
                        xlinkHref: '#' + this.idPrefix + 'a'
                    }),
                    React.createElement('path', {
                        className: 'fill-color',
                        fill: '#C3C3C3',
                        d: 'M5.5 25.1C6.7 21 10 18 14 18s7.3 3 8.5 7.1a14 14 0 0 1-17 0zM14 16a5 5 0 1 1 0-10 5 5 0 0 1 0 10z'
                    })
                )
            );
        }
    }]);

    return UnknownUserAvatar;
}(React.PureComponent);

UnknownUserAvatar.defaultProps = {
    className: '',
    height: 28,
    width: 28
};
UnknownUserAvatar.propTypes = {
    className: PropTypes.string.isRequired,
    height: PropTypes.number,

    /** A text-only string describing the icon if it's not purely decorative for accessibility */
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    width: PropTypes.number
};


export default UnknownUserAvatar;
import PropTypes from 'prop-types';